import { AuthProvider } from "react-admin";
import { getKeycloak } from "./keycloak";

const authProvider: AuthProvider = {
  login: () => Promise.resolve(), // no-op

  checkAuth: () => {
    const hash = window.location.hash;
    if (hash.startsWith("#/externals")) {
      return Promise.resolve(); // bypass Keycloak
    }
    const kc = getKeycloak();
    return kc.authenticated
      ? Promise.resolve()
      : Promise.reject({ redirectTo: window.location.origin });
  },

  checkError: ({ status }) =>
    status === 401 || status === 403 ? Promise.reject() : Promise.resolve(),

  getPermissions: () => {
    const roles = getKeycloak().tokenParsed?.realm_access?.roles || [];
    return Promise.resolve(roles);
  },

  // logout via Keycloak
  logout: async () => {
    const kc = getKeycloak();
    kc.logout();
    localStorage.removeItem("kc_token");
    localStorage.removeItem("kc_refreshToken");
  },

  getIdentity: () => {
    const profile = getKeycloak().tokenParsed as any;
    return Promise.resolve({
      id: profile.sub,
      fullName: profile.preferred_username,
    });
  },
};

export default authProvider;
